import { motion } from "framer-motion";
import { tr } from "@/lib/i18n";

const RANK_BG = ["#FFD700", "#E5E7EB", "#F4A460"];

export const ScoreboardScene = ({ players, lang, onNext, isLast }) => (
  <div className="absolute inset-0" data-testid="host-scoreboard-scene">
    <div className="store-bg" style={{ filter: "brightness(0.3) blur(3px)", transform: "scale(1.05)" }} />
    <div className="absolute left-0 right-0 top-[3em] text-center">
      <span className="font-press text-[3em] text-[#FFD700]" style={{ textShadow: "0.12em 0.12em 0 #000" }}>{tr(lang, "scoreboard").toUpperCase()}</span>
    </div>
    <div className="absolute left-[8em] right-[8em] top-[10em] flex flex-col gap-[1.4em]">
      {players.slice(0, 5).map((p, i) => (
        <motion.div
          key={p.id}
          data-testid={`host-scoreboard-row-${i + 1}`}
          initial={{ x: "30em", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.15 + i * 0.12, type: "spring", stiffness: 220, damping: 22 }}
          className="px-box flex items-center px-[1.4em] h-[6.2em]"
          style={{ background: RANK_BG[i] || "#fffbe8" }}
        >
          <span className="font-num text-[3.2em] w-[2em] leading-none">{i + 1}</span>
          <span className="font-pixel font-bold text-[2.8em] flex-1 truncate">{p.name}</span>
          {p.last_points > 0 && <span className="font-num text-[2em] text-[#1a7a08] mr-[1.2em] leading-none">+{p.last_points}</span>}
          <span className="font-num text-[3.2em] leading-none">{p.score}</span>
        </motion.div>
      ))}
    </div>
    <button data-testid="host-scoreboard-next-button" className="px-btn text-[1.5em] absolute right-[2em] bottom-[2em]" onClick={onNext}>
      {isLast ? tr(lang, "show_results") : tr(lang, "next")} ▶
    </button>
  </div>
);
